const DEFAULT_ORIGIN = 'https://stagster.com';

const stripTrailingSlash = (value) => value.replace(/\/$/, '');

const normaliseOrigin = (value) => {
  if (!value) return null;
  const trimmed = value.trim();
  if (!trimmed) return null;
  try {
    const url = new URL(trimmed.startsWith('http') ? trimmed : `https://${trimmed}`);
    return `${url.protocol}//${url.host}`;
  } catch (_) {
    return null;
  }
};

export const getPublicOrigin = () => {
  const envOrigin = normaliseOrigin(process.env.REACT_APP_PUBLIC_ORIGIN);
  if (envOrigin) return stripTrailingSlash(envOrigin);

  const envDomain = normaliseOrigin(process.env.REACT_APP_PUBLIC_DOMAIN);
  if (envDomain) return stripTrailingSlash(envDomain);

  if (typeof window !== 'undefined' && window.location?.origin) {
    return stripTrailingSlash(window.location.origin);
  }

  return stripTrailingSlash(DEFAULT_ORIGIN);
};

export const isSameHost = (hostname) => {
  if (!hostname) return false;
  try {
    const origin = new URL(getPublicOrigin());
    return origin.hostname.toLowerCase() === hostname.toLowerCase();
  } catch (_) {
    return false;
  }
};

export const rebaseUrl = (value) => {
  if (!value) return value;
  const origin = getPublicOrigin();

  if (typeof value === 'string' && value.startsWith('http')) {
    try {
      const url = new URL(value);
      if (['stagster.com', 'www.stagster.com'].includes(url.hostname)) {
        const newOrigin = new URL(origin);
        url.protocol = newOrigin.protocol;
        url.host = newOrigin.host;
        return url.toString();
      }
      return url.toString();
    } catch (_) {
      return value;
    }
  }

  if (typeof value === 'string') {
    const cleanValue = value.startsWith('/') ? value : `/${value}`;
    return `${origin}${cleanValue}`;
  }

  return value;
};

export const buildAbsoluteUrl = (input = '') => {
  if (!input) return getPublicOrigin();
  return rebaseUrl(input);
};

export const buildAssetUrl = (path = '') => {
  if (!path) return getPublicOrigin();
  if (/^https?:\/\//i.test(path)) return path;
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  return `${getPublicOrigin()}${cleanPath}`;
};
